export default __webpack_public_path__ + "static/char-t-21-zh-Hans-2fdedfbcd9a43f3392b0a45bdcb5e037.webp";